import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    return (
        <>
            <EfImg
                pc="https://websiteoss.ecoflow.com/upload/image/1724561329321/high_light_5.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1724561329321/high_light_5.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1724568914398/high_light_5_h5.jpg"
            />
            <div className="card-box card-box-5">
                <div className="card-title">{t('item5_title')}</div>
                <div className="card-desc">{t('item5_desc')}</div>
            </div>
        </>
    );
}
